import React, { useEffect } from 'react'
import { useCookies } from 'src/Libs/cookies'
import InvitationsDialog from './InvitationsDialog'
import CompanyInvitation from './CompanyInvitationWithToken'
import ChangeEmailConfirmation from '../User/UserProfile/ChangeEmailConfirmation'
import {
  CHANGE_EMAIL_AND_USERNAME_QUERY_PARAM,
  CHANGE_EMAIL_QUERY_PARAM,
  COMPANY_QUERY_TOKEN_PARAM,
  GIFT_CODE_QUERY_TOKEN_PARAM,
  INSTALLATION_INVITATION_TOKEN_QUERY_PARAM,
  PROTECTED_FILE_QUERY_PARAM,
} from 'src/Libs/navigation/consts'
import { AmazonCodeDialog } from 'src/Libs/referral'
import { useSearchParams } from 'react-router-dom'
import ProtectedFileDialog from 'src/Libs/downloads/components/ProtectedFileDialog'
import InvitationCheck from './InvitationCheck'

/**
 * Component to handle invitation and change Email tokens on Framework
 */
const Tokens: React.FC = () => {
  const { cookies, setTokens, removeTokens } = useCookies()
  const [searchParams] = useSearchParams()

  const changeEmailToken = searchParams.get(CHANGE_EMAIL_QUERY_PARAM)
  const changeEmailAndUsernameToken = searchParams.get(CHANGE_EMAIL_AND_USERNAME_QUERY_PARAM)
  const invitationToken = searchParams.get(INSTALLATION_INVITATION_TOKEN_QUERY_PARAM)
  const companyToken = searchParams.get(COMPANY_QUERY_TOKEN_PARAM)
  const giftCodeToken = searchParams.get(GIFT_CODE_QUERY_TOKEN_PARAM)
  const protectedFileToken = searchParams.get(PROTECTED_FILE_QUERY_PARAM)

  useEffect(() => {
    setTokens({
      invitationToken: invitationToken ?? undefined,
      companyToken: companyToken ?? undefined,
      changeEmailToken: changeEmailToken ?? undefined,
      changeEmailAndUsernameToken: changeEmailAndUsernameToken ?? undefined,
      giftCodeToken: giftCodeToken ?? undefined,
      protectedFileToken: protectedFileToken ?? undefined,
    })
  }, [invitationToken, companyToken, changeEmailToken, giftCodeToken, setTokens, changeEmailAndUsernameToken, protectedFileToken])

  if (cookies.invitationToken || invitationToken)
    return <InvitationsDialog onClose={removeTokens} invitationToken={cookies.invitationToken ?? invitationToken ?? undefined} />
  if (cookies.companyToken) return <CompanyInvitation removeInvitationToken={removeTokens} invitationToken={cookies.companyToken} />
  if (cookies.changeEmailToken) return <ChangeEmailConfirmation removeChangeEmailToken={removeTokens} changeEmailToken={cookies.changeEmailToken} />
  if (cookies.changeEmailAndUsernameToken)
    return <ChangeEmailConfirmation removeChangeEmailToken={removeTokens} changeEmailToken={cookies.changeEmailAndUsernameToken} isUsernameChange />
  if (cookies.giftCodeToken) return <AmazonCodeDialog removeAmazonCodeToken={removeTokens} amazonCodeId={cookies.giftCodeToken} />
  if (cookies.protectedFileToken) {
    return <ProtectedFileDialog deleteFileNameToken={removeTokens} protectedFileName={cookies.protectedFileToken} />
  }
  return <InvitationCheck />
}

export default Tokens
